const env = {
  SERVER: 'https://api.dev.stayloyal.net',
  API_URL: 'https://api.dev.stayloyal.net/api',
}

export default env
